export enum GameBoardZIndex {
	Background = 0,
	Dim = 1,
	Content = 2,
	Overlay = 3,
	FacilitatorUI = 10,
	Transition = 20,
}
